import { apiClient } from '@/core/api/client';

export const smsReallocationAPI = {
  /**
   * Reassign an inbox SMS to a different affaire
   */
  async reassignSms(smsId: string, targetAffaireId: number): Promise<{ success: boolean; message: string }> {
    return apiClient.put<{ success: boolean; message: string }>(
      `/api/sms-gateway/admin/inbox/${smsId}/reassign`,
      { targetAffaireId }
    );
  },

  /**
   * Unlink an inbox SMS from its current affaire
   */
  async unlinkSms(smsId: string): Promise<{ success: boolean; message: string }> {
    return apiClient.put<{ success: boolean; message: string }>(
      `/api/sms-gateway/admin/inbox/${smsId}/reassign`,
      { targetAffaireId: null }
    );
  },

  /**
   * Reassign all inbox SMS from a phone number to an affaire
   */
  async reassignByPhone(phoneNumber: string, targetAffaireId: number): Promise<{ success: boolean; message: string }> {
    return apiClient.put<{ success: boolean; message: string }>(
      `/api/sms-gateway/admin/inbox/reassign-by-phone`,
      { phoneNumber, targetAffaireId }
    );
  },

  /**
   * Unlink all inbox SMS from a phone number
   */
  async unlinkByPhone(phoneNumber: string): Promise<{ success: boolean; message: string }> {
    return apiClient.put<{ success: boolean; message: string }>(
      `/api/sms-gateway/admin/inbox/reassign-by-phone`,
      { phoneNumber, targetAffaireId: null }
    );
  },
};
